/**
 * Единая точка для baseURL API.
 * - aidovut.tech всегда https (в т.ч. если в CI задан http://)
 * - Если API_URL не задан — same-origin (/api/v1/... через nginx)
 */
export function resolveApiBaseUrl(raw?: string): string | undefined {
  const env = raw ?? process.env.API_URL;
  if (!env || env === '/' || env === 'same-origin') return undefined;

  let normalized = env.endsWith('/') ? env.slice(0, -1) : env;

  if (/aidovut\.tech/i.test(normalized)) {
    normalized = normalized.replace(/^http:\/\//i, 'https://');
  } else if (
    typeof window !== 'undefined' &&
    window.location.protocol === 'https:' &&
    normalized.startsWith('http://')
  ) {
    normalized = normalized.replace(/^http:/, 'https:');
  }

  return normalized;
}

export function normalizeApiPath(url: string): string {
  if (url.startsWith('api/v1/')) return `/${url}`;
  if (!url.startsWith('http') && !url.startsWith('/')) return `/${url}`;
  return url;
}

/** Полный URL — axios не подставит http:// из defaults. */
export function buildAbsoluteApiUrl(path: string): string {
  let url = normalizeApiPath(path);

  if (/aidovut\.tech/i.test(url)) {
    url = url.replace(/^http:\/\//i, 'https://');
  } else if (
    typeof window !== 'undefined' &&
    window.location.protocol === 'https:' &&
    url.startsWith('http://')
  ) {
    url = url.replace(/^http:/, 'https:');
  }

  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }

  if (url.startsWith('/')) {
    const base = resolveApiBaseUrl();
    if (base) return `${base}${url}`;
    if (typeof window !== 'undefined') return `${window.location.origin}${url}`;
  }

  return url;
}

/** Каждый запрос — только абсолютный https URL, без baseURL. */
export function applyApiBaseToRequestConfig(config: {
  url?: string;
  baseURL?: string;
}) {
  if (typeof config.url !== 'string') return;

  config.url = buildAbsoluteApiUrl(config.url);
  config.baseURL = undefined;
}
